import { render, staticRenderFns } from "./MenuMonitoramento.vue?vue&type=template&id=d84cbd08&scoped=true"
import script from "./MenuMonitoramento.vue?vue&type=script&lang=js"
export * from "./MenuMonitoramento.vue?vue&type=script&lang=js"
import style0 from "./MenuMonitoramento.vue?vue&type=style&index=0&id=d84cbd08&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d84cbd08",
  null
  
)

export default component.exports